export enum EButtonSize {
  Large = 'large',
  Middle = 'middle',
  Small = 'small',
}
